export function convertAttacks(newData: any) {
  let attacksRet = "";
  for (let i = 0; i < newData.attacks.length; i++) {
    attacksRet += "damageDice:" + newData.attacks[i].damageDice + "+";
    attacksRet += "number:" + newData.attacks[i].number + "+";
    attacksRet += "weapon:" + newData.attacks[i].weapon + "|";
  }
  return attacksRet;
}
export function convertAttackSkills(newData: any) {
  let attackSkillsRet = "";
  for (let i = 0; i < newData.attackSkills.length; i++) {
    attackSkillsRet += "cost:" + newData.attackSkills[i].cost + "+";
    attackSkillsRet += "name:" + newData.attackSkills[i].name + "+";
    attackSkillsRet += "number:" + newData.attackSkills[i].number + "+";
    attackSkillsRet += "ranks:" + newData.attackSkills[i].ranks + "|";
  }
  return attackSkillsRet;
}
export function convertRollString(newData: any) {
  let rollStringRet = "";
  for (let i = 0; i < newData.rollString.length; i++) {
    rollStringRet += newData.rollString[i] + "|";
  }
  return rollStringRet;
}
export function convertAttacksBack(attacks: string) {
  const attacksObj = [];
  const attacksRet = attacks.split("|");
  for (let i = 0; i < attacksRet.length - 1; i++) {
    const damageDiceIndex = attacksRet[i].indexOf(":") + 1;
    const damageDiceIndexEnd = attacksRet[i].indexOf("+");
    const numberIndex = attacksRet[i].indexOf(":", damageDiceIndex) + 1;
    const numberIndexEnd = attacksRet[i].indexOf("+", numberIndex);
    const weaponIndex = attacksRet[i].indexOf(":", numberIndex) + 1;
    const obj = {
      damageDice: attacksRet[i].substring(damageDiceIndex, damageDiceIndexEnd),
      number: parseInt(attacksRet[i].substring(numberIndex, numberIndexEnd)),
      weapon: attacksRet[i].substring(weaponIndex),
    };
    attacksObj.push(obj);
  }
  return attacksObj;
}

export function convertAttackSkillsBack(attackSkills: string) {
  const attacksObj = [];
  const attackSkillsRet = attackSkills.split("|");
  for (let i = 0; i < attackSkillsRet.length - 1; i++) {
    const costIndex = attackSkillsRet[i].indexOf(":") + 1;
    const costIndexEnd = attackSkillsRet[i].indexOf("+");
    const nameIndex = attackSkillsRet[i].indexOf(":", costIndex) + 1;
    const nameIndexEnd = attackSkillsRet[i].indexOf("+", nameIndex);
    const numberIndex = attackSkillsRet[i].indexOf(":", nameIndex) + 1;
    const numberIndexEnd = attackSkillsRet[i].indexOf("+", numberIndex);
    const ranksIndex = attackSkillsRet[i].indexOf(":", numberIndex) + 1;
    const obj = {
      cost: parseInt(attackSkillsRet[i].substring(costIndex, costIndexEnd)),
      name: attackSkillsRet[i].substring(nameIndex, nameIndexEnd),
      number: parseInt(
        attackSkillsRet[i].substring(numberIndex, numberIndexEnd)
      ),
      weapon: attackSkillsRet[i].substring(ranksIndex),
    };
    attacksObj.push(obj);
  }
  return attacksObj;
}

export function convertRollStringBack(rollString: string) {
  const res = rollString.substring(0, rollString.length - 1);
  return res.split("|");
}
